import { Purchases } from '@revenuecat/purchases-js'

export const ENTITLEMENT_ID = 'pro'

let purchasesInstance: Purchases | null = null

export function initRevenueCat(appUserID: string): Purchases | null {
  const apiKey = import.meta.env.VITE_REVENUECAT_API_KEY as string | undefined
  if (!apiKey) {
    console.warn('RevenueCat API key not configured — billing disabled')
    return null
  }

  purchasesInstance = Purchases.configure(apiKey, appUserID)
  return purchasesInstance
}

export function getPurchases(): Purchases | null {
  return purchasesInstance
}
